import React from "react";
import { Link } from "react-router-dom";
import SidebarAdmin from "./SidebarAdmin";
import "../pages/Styles/Admin.css";

const AdminFormLayout = ({
  title,
  backTo,
  backLabel = "Back",
  children,
}) => {
  return (
    <div className="admin-shell">
      <SidebarAdmin />
      <main className="admin-content">
        {backTo && (
          <Link to={backTo} className="admin-back-link">
            Back: {backLabel}
          </Link>
        )}
        <div className="admin-form-card">
          <h1 className="admin-page-title">{title}</h1>
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminFormLayout;
